import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";
import { announceCurrencyChange } from "@/lib/wallet/sync";
import { User, UserBalance } from "@/types";

export const getBalance = async (): Promise<UserBalance> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.BALANCE.GET,
    errorMessage: "Failed to get user balance",
  });
};

export interface PlayerWallet {
  baseCurrency: string;
  currency: string;
  balance: number;
  locked: number;
  active: boolean;
  /** The row's worth in USD; SKY is converted at the admin rate. */
  usdValue?: number;
  baseAmount: number | null;
}

export interface PlayerWallets {
  enabled: boolean;
  wallets: PlayerWallet[];
  showOptions: {
    label: string;
    value: string;
    symbol?: string;
    icon?: string;
    rate: number | null;
  }[];
}

export const getPlayerWallets = async (): Promise<PlayerWallets> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.BALANCE.WALLETS,
    errorMessage: "Failed to get wallets",
  });
};

export const changeShowCurrency = async ({ currency }: { currency: string }): Promise<User> => {
  const user: User = await apiRequest({
    method: "POST",
    url: API_ENDPOINTS.BALANCE.CHANGE_SHOW_CURRENCY,
    data: { currency },
    errorMessage: "Failed to change show currency",
  });
  announceCurrencyChange(user);
  return user;
};

export const changeCurrency = async ({ currency }: { currency: string }): Promise<User> => {
  const user: User = await apiRequest({
    method: "POST",
    url: API_ENDPOINTS.BALANCE.CHANGE_CURRENCY,
    data: { currency },
    errorMessage: "Failed to change currency",
  });
  announceCurrencyChange(user);
  return user;
};
